import { render, staticRenderFns } from "./BeepCode.vue?vue&type=template&id=8a165920&scoped=true&"
import script from "./BeepCode.vue?vue&type=script&lang=js&"
export * from "./BeepCode.vue?vue&type=script&lang=js&"
import style0 from "./BeepCode.vue?vue&type=style&index=0&id=8a165920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a165920",
  null
  
)

export default component.exports